export default __webpack_public_path__ + "static/tech-nation-2-343d604a3147684426697df646359890.webp";